import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorksheetDto } from '../../../models/worksheet-dto.interface';

@Component({
  selector: 'app-job-worksheet-header',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './job-worksheet-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JobWorksheetHeaderComponent {
  @Input() worksheet!: WorksheetDto;

}
